export default __webpack_public_path__ + "images/abf27d8c87140db65bb357cd5530b05c-state_government_small.webp";